import styled from 'styled-components';

import { useGlobalStore } from '../../state/globalStore';

const Notification = () => {
  const notification = useGlobalStore((store) => store.notification);
  if (!notification) {
    return <></>;
  }
  return <NotificationToast>{notification.message}</NotificationToast>;
};

export default Notification;

const NotificationToast = styled.div`
  position: fixed;
  bottom: 1.75rem;
  z-index: 1000;
  color: white;
  left: 50%;
  min-width: 8.75rem;
  padding: 0.6875rem 1.25rem;
  border-radius: 0.1875rem;
  background: rgba(0, 0, 0, 0.9);
  box-shadow: 0 0.375rem 0.625rem 0 rgba(0, 0, 0, 0.12);
  text-align: center;
  -webkit-transform-origin: 50 50;
  -ms-transform-origin: 50 50;
  transform-origin: 50 50;
  border: 1px solid rgba(255, 255, 255, 0.25);
  overflow: hidden;
  @keyframes smooth-appear {
    from {
      -webkit-transform: translate(-50%, 100px);
      transform: translate(-50%, 100px);
    }
    to {
      -webkit-transform: translate(-50%, 0);
      transform: translate(-50%, 0);
    }
  }
  animation: smooth-appear 0.5s ease forwards;
`;
